export default {
  description: 'Here is a summary of our libraries on GitHub.',
  title: 'Free C# Libraries'
}
